import moment from 'moment';

export default function LoaderHelper(startTime, callback) {
  const endTime = moment();
  const diffSeconds = Math.abs(startTime.diff(endTime, 'seconds', true));

  // Show a minimum amount of loader feedback to the User
  if (diffSeconds < 2) {
    setTimeout(() => {
      return callback();
    }, 1500)
  } else {
    return callback();
  }
}



// WEBPACK FOOTER //
// ./src/client/helpers/utilities/loader-helper.jsx